import { render } from "./Add.vue?vue&type=template&id=4bce963a"
import script from "./Add.vue?vue&type=script&setup=true&lang=js"
export * from "./Add.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/client_levels/components/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bce963a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bce963a', __exports__)) {
    api.reload('4bce963a', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=4bce963a", () => {
    api.rerender('4bce963a', render)
  })

}


export default __exports__